<template>
  <section class="text-center">
    <p>Etes-vous sûr de vouloir supprimer '<strong>Ridi Nsimba Luamba</strong>'</p>
    <div class="">
      <button class="btn btn-outline-danger">NON</button>
      <button class="ml-3 btn btn-outline-success">OUI</button>
    </div>
  </section>
</template>

<script>
export default {
name: "Delete"
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilisateurs/components/Delete.vue